<template>
  <div id="register-setting-page">
    <div class="page-name">
      <span class="page-title">FACEBOOK</span>
    </div>
    <div class="page-container">
      <b-card class="w-100">
        <h5 class="my-3">Setting Facebook</h5>
        <b-tabs>
          <b-tab
            v-for="(tab, index) in tabs"
            :key="index"
            :title="tab.label"
            @click="selectedTab = tab.value"
            :active="selectedTab === tab.value"
          >
            <facebook-config v-if="tab.value === 'facebook_config'" />
            <tag-project-page v-else-if="tab.value === 'tag_project_page'" />
            <tag-thank-you-page v-else-if="tab.value === 'tag_thankyou_page'" />
          </b-tab>
        </b-tabs>
      </b-card>
      <br />
    </div>
  </div>
</template>

<script>
import FacebookConfig from '@/components/facebook-seo-form/FacebookCofig'
import TagProjectPage from '@/components/facebook-seo-form/TagProjectPage'
import TagThankYouPage from '@/components/facebook-seo-form/TagThankYouPage'

export default {
  components: {
    FacebookConfig,
    TagProjectPage,
    TagThankYouPage,
  },
  data: () => ({
    tabs: [
      {
        label: 'Facebook Config',
        value: 'facebook_config',
      },
      {
        label: 'Tag Project Page',
        value: 'tag_project_page',
      },
      {
        label: 'Tag Thankyou Page',
        value: 'tag_thankyou_page',
      },
    ],
    selectedTab: 'facebook_config',
  }),
}
</script>

<style>
td {
  vertical-align: middle !important;
  font-size: 14px;
}
</style>
